/* ============================================================
   Vantor — Contact form inquiry types (TPC-174).
   FIELDS is the one table: per field, the inquiry types that show
   it and whether it is required there. A type that is absent hides
   the field. `tag` marks a field whose label says "Optional" when
   it is optional. COPY and FORMATS are the error sentences and the
   the format rules. scripts/test-contact.mjs holds the snippet to it.
   ============================================================ */
(function (V) {
  var TYPES = [
    { key: 'general', label: 'General' },
    { key: 'distributor', label: 'Become a retailer' },
    { key: 'bulk', label: 'Bulk order' }
  ];
  var FIELDS = {
    name:     { general: 'required', distributor: 'required', bulk: 'required' },
    email:    { general: 'required', distributor: 'required', bulk: 'required' },
    phone:    { distributor: 'optional', tag: true },
    truck:    { general: 'optional', tag: true },
    company:  { distributor: 'required', bulk: 'optional', tag: true },
    street:   { distributor: 'required' },
    city:     { distributor: 'required' },
    state:    { distributor: 'required' },
    zip:      { distributor: 'required' },
    installs: { distributor: 'required' },
    quantity: { bulk: 'required' },
    body:     { general: 'required', distributor: 'optional', bulk: 'required', tag: true }
  };
  var COPY = { empty: 'Fill in this field.', email: 'Enter a valid email address.', quantity: 'Enter a whole number.', zip: 'Enter a 5-digit ZIP code.' };
  var EMPTY = { state: 'Choose a state.', installs: 'Choose one.' };
  /* Each runs on the trimmed value. quantity is the input's own `pattern`, which with no script does not trim. */
  var FORMATS = { email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/, quantity: /^[1-9][0-9]*$/, zip: /^\d{5}(-\d{4})?$/ };

  function typeFromSearch(search) {
    var m = /(?:^|[?&])inquiry=([^&]*)/.exec(search);
    var known = m && TYPES.some(function (t) { return t.key === m[1]; });
    return known ? m[1] : TYPES[0].key;
  }

  /**
   * apply(type, fields)
   *   fields — { name: { wrap, controls, tag } } for every name in FIELDS; tag may be null.
   * Hidden fields are disabled so the email never carries one from a type the person left.
   * No value is written, so what was typed survives any number of type changes.
   */
  function apply(type, fields) {
    Object.keys(FIELDS).forEach(function (name) {
      var f = fields[name], state = FIELDS[name][type];
      f.wrap.hidden = !state;
      f.controls.forEach(function (c) { c.disabled = !state; c.required = state === 'required'; });
      if (f.tag) f.tag.hidden = !(state === 'optional' && FIELDS[name].tag);
    });
  }

  /**
   * errorsFor(type, values) -> { name: message }, in form order, for the fields the type shows.
   *   values — { name: string }; a missing name is empty.
   */
  function errorsFor(type, values) {
    var errors = {};
    Object.keys(FIELDS).forEach(function (name) {
      var state = FIELDS[name][type], value = (values[name] || '').trim();
      if (!state) return;
      if (!value) { if (state === 'required') errors[name] = EMPTY[name] || COPY.empty; }
      else if (FORMATS[name] && !FORMATS[name].test(value)) errors[name] = COPY[name];
    });
    return errors;
  }

  /**
   * paint(errors, fields)
   *   fields — { name: { controls, error } }; error is the slot under the controls.
   * Shows each message and clears every other slot. No value is written.
   */
  function paint(errors, fields) {
    Object.keys(fields).forEach(function (name) {
      var f = fields[name], message = errors[name] || '';
      if (!f.error) return;
      f.error.textContent = message;
      f.error.hidden = !message;
      f.controls.forEach(function (c) {
        if (message) c.setAttribute('aria-invalid', 'true');
        else c.removeAttribute('aria-invalid');
      });
    });
  }

  /* A formatted field is sent as checked: " 12 " goes out as "12". Free text stays as typed. */
  function tidy(fields) {
    Object.keys(FORMATS).forEach(function (name) {
      if (fields[name]) fields[name].controls[0].value = fields[name].controls[0].value.trim();
    });
  }

  function value(f) {
    if (f.controls[0].type !== 'radio') return f.controls[0].value;
    var on = f.controls.filter(function (c) { return c.checked; })[0];
    return on ? on.value : '';
  }

  function focusTarget(f) {
    return f.controls.filter(function (c) { return c.checked; })[0] || f.controls[0];
  }

  function fieldsIn(root) {
    var fields = {};
    [].forEach.call(root.querySelectorAll('[data-field]'), function (wrap) {
      fields[wrap.getAttribute('data-field')] = { wrap: wrap, controls: [].slice.call(wrap.querySelectorAll('input, select, textarea')),
        tag: wrap.querySelector('[data-optional]'), error: wrap.querySelector('[data-error]') };
    });
    return fields;
  }

  function check(type, fields) {
    var values = {};
    Object.keys(fields).forEach(function (name) { values[name] = value(fields[name]); });
    return errorsFor(type, values);
  }

  /* Between two Sends an error can only change or go: a field showing none gains none. */
  function repaint(type, fields) {
    var errors = check(type, fields), shown = {};
    Object.keys(errors).forEach(function (name) {
      if (fields[name].error && !fields[name].error.hidden) shown[name] = errors[name];
    });
    paint(shown, fields);
  }

  V.contact = { TYPES: TYPES, FIELDS: FIELDS, typeFromSearch: typeFromSearch, apply: apply, errorsFor: errorsFor, tidy: tidy, paint: paint, repaint: repaint, check: check, fieldsIn: fieldsIn, focusTarget: focusTarget };

  var form = document.getElementById('ContactForm');
  if (!form) return;
  var select = form.querySelector('#cf-type'), fields = fieldsIn(form);
  function type() { return select.options[select.selectedIndex].getAttribute('data-type'); }
  function sync() { apply(type(), fields); }
  function refresh() { repaint(type(), fields); }
  function onSubmit(event) {
    if (event.target !== form) return;
    tidy(fields);
    var errors = check(type(), fields), first = Object.keys(errors)[0];
    paint(errors, fields);
    if (!first) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    focusTarget(fields[first]).focus();
    var head = document.querySelector('.site-head');
    var wrap = fields[first].wrap;
    if (head && wrap.getBoundingClientRect) {
      var bar = head.getBoundingClientRect().bottom;
      var top = wrap.getBoundingClientRect().top;
      if (top < bar) window.scrollBy(0, top - bar);
    }
  }
  select.querySelector('[data-type="' + typeFromSearch(location.search) + '"]').selected = true;
  select.addEventListener('change', sync);
  sync();

  /* The browser's bubble would pre-empt the errors under the fields. With no script the native checks stay. */
  form.noValidate = true;
  /* Shopify's captcha script listens for this submit too and can send the form itself, so this runs first. */
  document.addEventListener('submit', onSubmit, true);
  /* a change of Inquiry type bubbles here as well */
  form.addEventListener('input', refresh);
  form.addEventListener('change', refresh);
})(window.Vantor = window.Vantor || {});
